import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getAtcClassifications = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/atc_classifications', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getAtcClassification = id => {
  return api.http.get(`/atc_classifications/${id}`)
}

export const searchAtcClassifications = term => {
  return api.http.get('/atc_classifications/select_search', {
    params: {
      term
    }
  })
}

export const getSelectAtcClassifications = (term, callback) => {
  searchAtcClassifications(term).then(response => {
    const { data } = response

    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteAtcClassification = id => {
  return api.http.delete(`/atc_classifications/${id}`)
}

export const restoreAtcClassification = id => {
  return api.http.put(`/atc_classifications/${id}/restore`)
}

export const editAtcClassification = atcClassification => {
  return api.http.put(`/atc_classifications/${atcClassification._id}`, atcClassification)
}

export const addAtcClassification = atcClassification => {
  return api.http.post('/atc_classifications', atcClassification)
}



// WEBPACK FOOTER //
// ./src/api/atcClassifications.js